export default __webpack_public_path__ + "static/helena-lopes-DkGIAjlIJu0-unsplash-22ceb625305d83f6a996bf91bce62ac5.jpg";